import { gql, type TypedDocumentNode } from "@apollo/client";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";
import type { CRMNote } from "@/types";
import type { GovernanceTitle } from "./types";

export interface PersonGovernanceRoleNode {
  id: string;
  status: string;
  title: GovernanceTitle;
  sectionId?: string | null;
  sectionName?: string | null;
  sectionLegacyId?: string | null;
  notes: CRMNote[];
}

export interface PersonFacilityGovernanceRoleNode {
  id: string;
  status: string;
  title: GovernanceTitle;
  facilityId: string;
  facilityName: string;
  facilityLegacyId?: string | null;
  facilitySectionId?: string | null;
  facilitySectionName?: string | null;
  facilitySectionLegacyId?: string | null;
  notes: CRMNote[];
}

export interface PersonGovernanceRolesQueryData {
  person: {
    id: string;
    facilityGovernanceRoles: PersonFacilityGovernanceRoleNode[];
    governanceRoles: PersonGovernanceRoleNode[];
  };
}

export interface PersonGovernanceRolesQueryVariables {
  pgaId: string;
}

export const PERSON_GOVERNANCE_ROLES_QUERY: TypedDocumentNode<
  PersonGovernanceRolesQueryData,
  PersonGovernanceRolesQueryVariables
> = gql`
  query PersonGovernanceRoles($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      facilityGovernanceRoles {
        id
        status
        title {
          id
          title
        }
        facilityId
        facilityName
        facilityLegacyId
        facilitySectionId
        facilitySectionName
        facilitySectionLegacyId
        notes {
          ...CRMNoteFields
        }
      }
      governanceRoles {
        id
        status
        title {
          id
          title
        }
        sectionId
        sectionName
        sectionLegacyId
        notes {
          ...CRMNoteFields
        }
      }
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;
